import branchManagementComponent from './branch_management.component';

import BranchManagementRoutes from './components/routes'
import BranchManagementItemHolds from './components/item_holds'
import BranchManagementLocationHolds from './components/location_holds'
import BranchManagementItemHistoryHolds from './components/items'
import BranchManagementLocationsHistoryHolds from './components/locations'
import BranchManagementBagoutsHistory from './components/bagouts'
import BranchManagementOrdersHistory from './components/orders'
import BranchManagementTankersHistory from './components/tankers'
import BranchManagementBypassCode from './components/bypass_code'
import BranchMgmtDailyBalanceSheet from './components/daily_balance_sheet'
import BranchManagementMonthlyReport from './components/monthly_report'
import BranchManagementDeletedShipments from './components/deleted_shipments'
import BranchManagementCancelledShipments from './components/cancelled_shipments'
import BranchManagementBranchPerformance from './components/branch_performance'
import BranchManagementFinalResidualCountCommit from './components/final_residual_count_commit'
import BranchManagementCashDeliveries from './components/cash_deliveries'
import BranchManagementTntBypassCode from './components/tnt_bypass_code'
import BranchManagementPhysicalCashCount from './components/physical_cash_count'
import BranchManagementLockOpenErrors from './components/lock_open_errors'
import BranchManagementBillingApproval from './components/billing_approval'
import BranchManagementCountVariances from './components/count_variances'
import BranchManagementRestoreRouteAssignments from './components/restore_route_assignments'
import BranchManagementStopPerformance from './components/stop_performance'
import BranchManagementCustomerPickupReports from './components/customer_pickup_reports'
import BranchManagementContactRequest from './components/contact_request'
import BranchManagementImportFileView from './components/import_file_view'
import BranchManagementStopScheduling from './components/stop_scheduling'
import BranchManagementBinManifest from './components/bin_manifest'
import BranchManagementDepositReports from './components/deposit_reports'
import BranchManagementAverageDailyVaultBalance from './components/average-daily-vault-balance'

let branchManagementModule = angular.module('branchManagement', [ 
    BranchManagementRoutes,
    BranchManagementItemHolds,
    BranchManagementLocationHolds,
    BranchManagementItemHistoryHolds,
    BranchManagementOrdersHistory,
    BranchManagementLocationsHistoryHolds,
    BranchManagementBagoutsHistory,
    BranchManagementTankersHistory,
    BranchManagementBypassCode,
    BranchMgmtDailyBalanceSheet,
    BranchManagementMonthlyReport,
    BranchManagementDeletedShipments,
    BranchManagementCancelledShipments,
    BranchManagementBranchPerformance,
    BranchManagementFinalResidualCountCommit,
    BranchManagementCashDeliveries,
    BranchManagementTntBypassCode,
    BranchManagementPhysicalCashCount,
    BranchManagementLockOpenErrors,
    BranchManagementBillingApproval,
    BranchManagementCountVariances,
    BranchManagementRestoreRouteAssignments,
    BranchManagementStopPerformance,
    BranchManagementCustomerPickupReports,
    BranchManagementContactRequest,
    BranchManagementImportFileView,
    BranchManagementStopScheduling,
    BranchManagementBinManifest,
    BranchManagementDepositReports,
    BranchManagementAverageDailyVaultBalance
  ])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $stateProvider
    .state('branchManagement.routes', {
      url: '/routes',
      component: 'branchManagementRoutes',
      data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_routes.all'
      }
    })
    .state('branchManagement.itemHolds', {
      url: '/item-holds',
      component: 'branchManagementItemHolds',
      data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_item_holds.all'
      }
    })
    .state('branchManagement.locationHolds', {
      url: '/location-holds',
      component: 'branchManagementLocationHolds',
      data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_item_holds.all'
      }
    })
    .state('branchManagement.items', {
      url: '/shipment-history/:id',
      params: { id: null },      
      component: 'branchManagementItemHistoryHolds',
      data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_items.all'
      }
    })
    .state('branchManagement.locations', {
      url: '/locations-history?locationId',
      params: {
        locationId: {
          dynamic: true
        }
      },
      component: 'branchManagementLocationsHistoryHolds',
      data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_locations.all'
      }
    })
    .state('branchManagement.bagouts', {
      url: '/bagouts-history',
      component: 'branchManagementBagoutsHistory',
      data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_bagouts.all'
      }
    })
    .state('branchManagement.orders', {
      url: '/order-history/:id',
      params: { id: null },
      component: 'branchManagementOrdersHistory',
      data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_orders.all'
      }
    })
    .state('branchManagement.tankers', {
      url: '/tankers-history',
      component: 'branchManagementTankersHistory',
      data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_tankers.all'
      }
    })
    .state('branchManagement.bypassCode', {
      url: '/4P-bypass-code',
      component: 'branchManagementBypassCode',
      data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_bypass_code.all'
      }
    })
    .state('branchManagement.dailyBalanceSheet', {
      url: '/daily-balance-sheet',
      component: 'branchMgmtDailyBalanceSheet',
      data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_daily_balance_sheet.all'
      }
    })
    .state('branchManagement.monthlyReport', {
      url: '/monthly-report',
      component: 'branchManagementMonthlyReport',
      data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_monthly_report.all'
      }
    })
    .state('branchManagement.deletedShipments', {
      url: '/deleted-shipments',
      component: 'branchManagementDeletedShipments',
      data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_deleted_shipments.all'
      }
    })
    .state('branchManagement.cancelledShipments', {
      url: '/cancelled-shipments',
      component: 'branchManagementCancelledShipments',
      data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_cancelled_shipments.all'
      }
    })
    .state('branchManagement.branchPerformance', {
      url: '/branch-performance',
      component: 'branchManagementBranchPerformance',
      data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_branch_performance.all'
      }
    })
    .state('branchManagement.finalResidualCountCommit', {
      url: '/final-residual-count-commit',
      component: 'branchManagementFinalResidualCountCommit',
      data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_final_residual_count_commit.all'
      }
    })
    .state('branchManagement.cashDeliveries', {
      url: '/cash-transactions',
      component: 'branchManagementCashDeliveries',
      data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_cash_transactions.all'
      }
    })
    .state('branchManagement.tntBypassCode', {
      url: '/TNT-bypass-code',
      component: 'branchManagementTntBypassCode',
      data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_tnt_bypass_code.all'
      }
    })
    .state('branchManagement.physicalCashCount', {
      url: '/physical-cash-count',
      component: 'branchManagementPhysicalCashCount',
      data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_physical_cash_count.all'
      }
    })
    .state('branchManagement.lockOpenErrors', {
      url: '/lock-open-errors',
      component: 'branchManagementLockOpenErrors',
      data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_lock_open_errors.all'
      }
    })
    .state('branchManagement.billingApproval', {
      url: '/billing-approval',
      component: 'branchManagementBillingApproval',
      data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_billing_approval.all'
      }
    })
    .state('branchManagement.countVariances', {
      url: '/count-variances',
      component: 'branchManagementCountVariances',
      data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_count_variances.all'
      }
    })
    .state('branchManagement.restoreRouteAssignments', {
      url: '/restore-route-assignments',
      component: 'branchManagementRestoreRouteAssignments',
      data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_restore_route_assignments.all'
      }
    })
    .state('branchManagement.stopPerformance', {
      url: '/stop-performance',
      component: 'branchManagementStopPerformance',
      data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_stop_performance.all'
      }
    })
    .state('branchManagement.customerPickupReports', {
      url: '/customer-pickup-reports',
      component: 'branchManagementCustomerPickupReports',
       data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_customer_pickup_reports.all'
       }
    })
    .state('branchManagement.contactRequest', {
      url: '/contact-request',
      component: 'branchManagementContactRequest',
       data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_contact_request.all'
       }
    })
    .state('branchManagement.importFileView', {
      url: '/import-file-view',
      component: 'branchManagementImportFileView',
       data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_import_file_view.all'
       }
    })
    .state('branchManagement.stopScheduling', {
      url: '/stop-scheduling',
      component: 'branchManagementStopScheduling',
      data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_stop_scheduling.all'
       }
    })
    .state('branchManagement.binManifest', {
      url: '/v2/index.html#/branch-management/bin-manifest',
      component: 'branchManagementBinManifest',
      data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_bin_manifest.all'
      }
    })
    .state('branchManagement.depositReports', {
      url: '/v2/index.html#/branch-management/deposit-record',
      component: 'branchManagementDepositReports',
      data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_deposit_reports.all'
      }
    })
    .state('branchManagement.averageDailyBalance', {
      url: '/v2/index.html#/branch-management/average-daily-balance',
      component: 'branchManagementAverageDailyVaultBalanceComponent',
      data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_average_daily_balance.all'
      }
    })
     .state('branchManagement.mileageReport', {
      url: '/v2/index.html#/branch-management/mileage-report',
      component: 'mileageReportComponent',
      data: {
        requireLogin: true,
        requireACL: 'branch_mgmt_mileage_report.all'
      }
    })
  })

  .component('branchManagement', branchManagementComponent)

  .name;

export default branchManagementModule;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/index.js